import { App } from "@capacitor/app";
import AuthApi from "api/auth";
import { useEffect } from "react";
import useBoundStore from "store";
import generateLocation from "utils/generateLocation";

function isSignUpUrl(hashParams: URLSearchParams) {
  return hashParams.get("type") === "signup";
}

function isRecoveryUrl(hashParams: URLSearchParams) {
  return hashParams.get("type") === "recovery";
}

function isGoogleSignInUrl(url: URL) {
  return AuthApi.DEEP_LINK === `${url.origin}${url.pathname.replace("//", "")}`;
}

export default function MobileNativeListener(): null {
  const setRedirect = useBoundStore((state) => state.navigation.setRedirect);
  const setMiscellaneous = useBoundStore((state) => state.miscellaneous.set);

  useEffect(() => {
    (async () => {
      App.addListener("appUrlOpen", async (data) => {
        const url = new URL(data.url);
        const hashParams = new URLSearchParams(url.hash.substring(1));

        if (isGoogleSignInUrl(url)) {
          AuthApi.setUserSession(hashParams);
          return;
        }

        if (isRecoveryUrl(hashParams) || isSignUpUrl(hashParams)) {
          AuthApi.setUserSession(hashParams);
        }

        setRedirect({
          location: generateLocation(url.href.replace(url.origin, "")),
          triggered: false,
        });
      });

      App.addListener("appStateChange", (data) => {
        setMiscellaneous({ isAppFocused: data.isActive });
      });
    })();

    return () => {
      (async () => App.removeAllListeners())();
    };
  }, []);

  return null;
}
